var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhonePeyV1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 14.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 14.5,
    stroke: "#D3D3D3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1291_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4468 9.4052C24.5605 8.7237 21.537 8.91336 18.7585 9.9502C15.98 10.987 13.5713 12.8245 11.837 15.2302C10.1028 17.6359 9.12084 20.5019 9.01535 23.4656C8.90986 26.4294 9.68557 29.3579 11.2444 31.8808C12.8032 34.4038 15.0751 36.4078 17.7729 37.6396C20.4706 38.8713 23.4731 39.2755 26.4005 38.8009C29.3279 38.3264 32.0489 36.9944 34.2194 34.9735C36.3898 32.9525 37.9123 30.3334 38.5943 27.4472C39.0471 25.5306 39.118 23.5435 38.8029 21.5995C38.4877 19.6555 37.7927 17.7926 36.7576 16.1172C35.7224 14.4418 34.3674 12.9868 32.7698 11.8351C31.1723 10.6834 29.3635 9.85775 27.4468 9.4052Z",
    fill: "#5F259F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8062 20.0865C30.798 19.8014 30.6803 19.5304 30.4775 19.3299C30.2747 19.1294 30.0025 19.0147 29.7173 19.0098H27.7056L23.0986 13.7193C22.8831 13.4771 22.6032 13.3013 22.2915 13.2122C21.9799 13.1232 21.6493 13.1246 21.3384 13.2164L19.7417 13.7193C19.685 13.7385 19.6337 13.7712 19.5924 13.8146C19.551 13.8579 19.5208 13.9106 19.5042 13.9682C19.4877 14.0258 19.4853 14.0865 19.4973 14.1452C19.5093 14.2039 19.5354 14.2588 19.5733 14.3052L24.605 19.0806H16.9829C16.9276 19.0782 16.8723 19.0873 16.8207 19.1074C16.769 19.1276 16.7222 19.1583 16.6831 19.1976C16.644 19.2369 16.6136 19.2839 16.5938 19.3357C16.5739 19.3874 16.5651 19.4427 16.5679 19.4981V20.3355C16.5729 20.6227 16.6892 20.8968 16.8924 21.0999C17.0955 21.303 17.3695 21.4193 17.6567 21.4244H18.8311V25.4478C18.8311 28.4629 20.4229 30.2232 23.1035 30.2232C23.9063 30.2478 24.7053 30.1048 25.4497 29.8033V32.4888C25.4474 32.6655 25.4805 32.8408 25.5471 33.0044C25.6136 33.1681 25.7123 33.3168 25.8372 33.4417C25.9621 33.5666 26.1108 33.6653 26.2744 33.7318C26.4381 33.7983 26.6134 33.8314 26.7901 33.8291H27.9619C28.0923 33.82 28.215 33.7641 28.3074 33.6717C28.3998 33.5793 28.4558 33.4566 28.4649 33.3262V21.3438H30.3862C30.4422 21.347 30.4982 21.3383 30.5506 21.3183C30.603 21.2983 30.6506 21.2675 30.6902 21.2279C30.7299 21.1882 30.7607 21.1407 30.7807 21.0883C30.8007 21.0359 30.8093 20.9799 30.8062 20.9239V20.0865ZM25.4351 27.2911C24.9066 27.5222 24.3345 27.6363 23.7578 27.6255C22.4175 27.6255 21.7485 26.9566 21.7485 25.4478V21.4268H25.4351V27.2862V27.2911Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1291_213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonePeyV1);
export default __webpack_public_path__ + "static/media/phone-pey-v1.92cad48afeedb4591fb7c76cc99b9840.svg";
export { ForwardRef as ReactComponent };